import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Slugify a heading string into a valid fragment identifier.
// Ensures uniqueness by allowing caller to append counters.
export function slugify(str) {
  return str
    .toLowerCase()
    .trim()
    .replace(/['`“”‘’]/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}
